import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=c078c92e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078c92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c078c92e')) {
      api.createRecord('c078c92e', component.options)
    } else {
      api.reload('c078c92e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=c078c92e&scoped=true&", function () {
      api.rerender('c078c92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G99XWqO4snmF/JS/comp/SearchFilterTokens.vue"
export default component.exports